import React from 'react';
import { CommonModal } from '../../../../../../global/modal/common/common-modal';
import DefaultButton from '../../../../../../global/default-button/default-button';
import { DefaultCloseModalButton } from '../../../../../../global/modal/common/common-close-modal-buttons';
import { SpeakerList } from './_speaker-list/speaker-list';
import { SyncSpeakersVM } from './sync-speakers.viewmodel';
import { observer } from 'mobx-react';
import './sync-speakers-modal.scss';
import {
    SYNC_SPEAKERS_MODAL_APPLY_BTN_TITLE,
    SYNC_SPEAKERS_MODAL_BODY_TITLE,
    SYNC_SPEAKERS_MODAL_TITLE,
    SYNC_SPEAKERS_PENDING_MESAGE
} from './sync-speakers-constants';

interface IProps {
    vm: SyncSpeakersVM;
}

const SyncSpeakersModal: React.FC<IProps> = observer(({vm}) => {
    const showPendingMessage = (): JSX.Element => {
        return vm.getIsLoading()
            ? (
                <span className='oe-popup-layout__footer-status-area'>
                    {SYNC_SPEAKERS_PENDING_MESAGE}
                </span>
            ) : null;
    };

    return vm ? (
        <CommonModal
            title={SYNC_SPEAKERS_MODAL_TITLE}
            isOpen={vm.getIsOpenSyncSpeakerModal()}
            onRequestClose={vm.closeSyncSpeakersModal}
            className='oe-modal-width sync-speakers-modal'
            footer={
                <>
                    {showPendingMessage()}
                    <div className="buttons-block buttons-block--from-right">
                        <DefaultButton
                            text={SYNC_SPEAKERS_MODAL_APPLY_BTN_TITLE}
                            onClick={vm.applySpeakersSync}
                            modifier={['fat']}
                        />
                        <DefaultCloseModalButton />
                    </div>
                </>
            }
        >
            <div className='sync-speakers-modal-body'>
                <h1 className='sync-speakers-modal-body__title'>
                    {SYNC_SPEAKERS_MODAL_BODY_TITLE}
                </h1>
                <SpeakerList
                    enabledSpeakers={vm.getEnabledSpeakers()}
                    disabledSpeakers={vm.getDisabledSpeakers()}
                    setSpeakers={vm.setEnabledSpeakers}
                    enableSpeaker={vm.enableSpeaker}
                    disableSpeaker={vm.disableSpeaker}
                    toggleBio={vm.toggleBio}
                />
            </div>
        </CommonModal>
    ) : null;
});

export { SyncSpeakersModal };
